module.exports = __webpack_public_path__ + "img/sumit-matica-mockup.7d64d446.png";